import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import Link from 'flarum/common/components/Link';
import CommentPost from 'flarum/forum/components/CommentPost';
const TAG = 'finance-business';
const PAGE = 20;

/**
 * A company's one comment thread, on its page. It's a Finance & Business discussion ("MTN Nigeria Communications
 * Plc (MTNN)"); the first person to comment starts it, and everyone after adds to it. Comments are full forum
 * posts (likes, edits, reports), newest or oldest first. attrs: symbol, name.
 */
export default class StockThread extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.symbol = this.attrs.symbol;
    this.discussionId = null;
    this.pending = false;
    this.title = '';
    this.posts = null;
    this.more = false;
    this.sort = 'newest';
    this.text = '';
    this.saving = false;
    this.notice = null;
    const pre = app.data && app.data.vouchaMarketsThread;
    if (pre && String(pre.symbol).toUpperCase() === this.symbol.toUpperCase()) {
      delete app.data.vouchaMarketsThread;
      this.apply(pre);
    } else {
      app.request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + '/voucha-markets/threads/' + this.symbol.toLowerCase(),
        errorHandler: () => {}
      }).then(r => this.apply(r || {})).catch(() => this.apply({}));
    }
  }
  apply(t) {
    this.discussionId = t.discussionId || null;
    this.pending = !!t.pending;
    this.title = t.title || this.attrs.name + ' (' + this.symbol + ')';
    if (this.discussionId) this.load(true);else this.posts = [];
    m.redraw();
  }
  load(reset) {
    if (reset) this.posts = null;
    const offset = reset || !this.posts ? 0 : this.posts.length;
    app.store.find('posts', {
      filter: {
        discussion: String(this.discussionId),
        type: 'comment'
      },
      sort: this.sort === 'newest' ? '-createdAt' : 'createdAt',
      include: 'user,user.groups,discussion,editedUser',
      page: {
        offset,
        limit: PAGE
      }
    }).then(list => {
      const got = Array.from(list || []);
      this.posts = (reset || !this.posts ? [] : this.posts).concat(got);
      this.more = got.length === PAGE;
    }).catch(() => this.posts = this.posts || []).then(() => m.redraw());
  }
  view() {
    const d = this.discussionId ? app.store.getById('discussions', String(this.discussionId)) : null;
    const count = d && d.commentCount ? d.commentCount() : this.posts ? this.posts.length : 0;
    return m('section.VouchaMarkets-section.VouchaThread', [m('.VouchaMk-sectionHead', [m('h2', count ? count + ' comment' + (count === 1 ? '' : 's') + ' on ' + this.symbol : 'Talk about ' + this.symbol), this.posts && this.posts.length > 1 ? m('.VouchaConv-modes', {
      role: 'group',
      'aria-label': 'Order'
    }, [this.sortButton('newest', 'Newest'), this.sortButton('oldest', 'Oldest')]) : null]), this.form(), this.notice ? m('p.VouchaThread-notice', this.notice) : null, this.posts === null ? m('p.VouchaMarkets-note', 'Loading comments…') : this.posts.length ? m('ol.VouchaThread-posts', this.posts.map(post => m('li', {
      key: post.id()
    }, m(CommentPost, {
      post
    })))) : !this.pending ? m('p.VouchaMarkets-note', 'No comments yet. Start the conversation about ' + this.symbol + '.') : null, this.more ? m('.VouchaMarkets-more', m(Button, {
      className: 'Button',
      onclick: () => this.load(false)
    }, 'Show more comments')) : null, d ? m('p.VouchaThread-link', m(Link, {
      href: app.route.discussion(d)
    }, 'Open as a discussion in Finance & Business →')) : null]);
  }
  sortButton(key, label) {
    return m('button', {
      type: 'button',
      className: this.sort === key ? 'is-on' : '',
      'aria-pressed': this.sort === key ? 'true' : 'false',
      onclick: () => {
        if (this.sort === key) return;
        this.sort = key;
        this.load(true);
      }
    }, label);
  }
  form() {
    if (this.pending) return m('p.VouchaMarkets-note', 'The first comment on ' + this.symbol + ' is waiting for approval. You can comment once it is published.');
    const user = app.session.user;
    if (!user) {
      return m('.VouchaThread-guest', [m('span', 'Log in to comment on ' + this.symbol + '.'), m(Button, {
        className: 'Button Button--primary',
        onclick: () => this.modal('LogInModal')
      }, 'Log in'), m(Button, {
        className: 'Button',
        onclick: () => this.modal('SignUpModal')
      }, 'Sign up')]);
    }
    return m('form.VouchaThread-form', {
      onsubmit: e => this.submit(e)
    }, [m('textarea', {
      rows: 3,
      placeholder: this.discussionId ? 'Add a comment about ' + this.symbol : 'Start the conversation about ' + this.symbol,
      'aria-label': 'Your comment',
      value: this.text,
      disabled: this.saving,
      oninput: e => this.text = e.target.value
    }), m('.VouchaThread-actions', [m(Button, {
      type: 'submit',
      className: 'Button Button--primary',
      loading: this.saving,
      disabled: this.saving || !this.text.trim()
    }, 'Post comment')])]);
  }
  modal(name) {
    try {
      const shown = app.modal.show(() => name === 'LogInModal' ? flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal') : flarum.reg.asyncModuleImport('flarum/forum/components/SignUpModal'));
      if (shown && shown.catch) shown.catch(() => {});
    } catch (e) {}
  }
  async submit(e) {
    e.preventDefault();
    const content = this.text.trim();
    if (!content || this.saving) return;
    this.saving = true;
    this.notice = null;
    try {
      if (this.discussionId) {
        const discussion = app.store.getById('discussions', String(this.discussionId)) || (await app.store.find('discussions', String(this.discussionId)));
        const post = await app.store.createRecord('posts').save({
          content,
          relationships: {
            discussion
          }
        });
        if (post.isApproved && post.isApproved() === false) this.notice = 'Thanks. Your comment will appear once a moderator approves it.';
      } else {
        // the first comment starts the company's discussion, then the page links it
        const tag = app.store.getBy('tags', 'slug', TAG);
        const discussion = await app.store.createRecord('discussions').save({
          title: this.title,
          content,
          relationships: {
            tags: tag ? [tag] : []
          }
        });
        const r = await app.request({
          method: 'POST',
          url: app.forum.attribute('apiUrl') + '/voucha-markets/threads/' + this.symbol.toLowerCase(),
          body: {
            discussionId: discussion.id()
          }
        });
        this.discussionId = r && r.discussionId || discussion.id();
        if (discussion.isApproved && discussion.isApproved() === false) this.notice = 'Thanks. Your comment will appear once a moderator approves it.';
      }
      this.text = '';
      this.sort = 'newest';
      this.load(true);
    } catch (err) {
      // Flarum shows the error (too long, posting too fast…) as an alert
    }
    this.saving = false;
    m.redraw();
  }
}
flarum.reg.add('voucha-markets', 'forum/components/StockThread', StockThread);